import { HTMLELEMENT } from '../../../../../../enums/HTMLELEMENT.js';
import OPTION, { Deselect, Select, Selectable } from '../../../../../DOM/form/fieldset/field/option/OPTION.js';
import EL from '../../../../../EL/EL.js';
import GROUP from '../../../../../DOM/GROUP/GROUP.js';
import { makeStruct } from '../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../enums/ModelData.js';
// Model Structure
export const optgroupAttr = makeAttrStruct([
    ['name'],
    ['label'],
    ['disabled']
]);
export const optgroupData = makeDataStruct([
// ['options', []]
]);
export const optgroupModel = makeStruct([
    ['attributes', optgroupAttr],
    ['data', optgroupData]
]);
/** Represents an <OPTIONGROUP> for a Select or Datalist*/
export default class OPTGROUP extends GROUP {
    constructor(node, model) {
        super(node, HTMLELEMENT.OPTGROUP, model);
    }
}
export { Deselect, EL, OPTION, Select, Selectable };
